import { httpClient } from '@/api/http-client';
import type { PosSessionRequestDto, PosSessionResponseDto } from '@carvia/ros-client-types';
class AdyenService {
  httpClient = httpClient;
  endpoint = '/adyen';

  async posSession(setupToken: string, bookingId?: string) {
    const res = await this.httpClient.post<PosSessionResponseDto>(`${this.endpoint}/pos-session`, {
      setupToken,
      bookingId,
    } as PosSessionRequestDto);
    return res.data;
  }
}

export const adyenService = new AdyenService();
